import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { IBreadcrumbsAndMenu } from "../../types/global";
import CustomizedBreadcrumbs from "../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuList from "../../components/Custom/CustomizedMenuList";
import { hasPermission } from "../../utils/Global";
import { useStateContext } from "../../contexts/auth-context";

const User = () => {
  const { t } = useTranslation();
  const {
    state: { permissions },
  } = useStateContext();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("user.index"),
    },
  ];

  const menuList: IBreadcrumbsAndMenu[] = [
    {
      name: t("user.account.index"),
      to: "account",
      permissionKey: "user_account",
    },
    {
      name: t("user.role.index"),
      to: "role",
      permissionKey: "role",
    },
    {
      name: t("user.setting.index"),
      to: "setting?tab=branch",
      permissionKey: "user_setting",
    },
  ].filter((item) => hasPermission(item.permissionKey, permissions));

  return (
    <Fragment>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <CustomizedMenuList menuList={menuList} />
    </Fragment>
  );
};

export default User;
